import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Profile from "@/components/Profile";
import PracticeAreas from "@/components/PracticeAreas";
import TrackRecord from "@/components/TrackRecord";
import Issues from "@/components/Issues";
import Approach from "@/components/Approach";
import LegalTech from "@/components/LegalTech";
import EngageForms from "@/components/EngageForms";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Landing() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      // Wait a beat for the sections to mount
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
    }
  }, [location]);

  return (
    <div className="bg-carbon text-warm min-h-screen" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Profile />
        <PracticeAreas />
        <TrackRecord />
        <Issues />
        <Approach />
        <LegalTech />
        <EngageForms />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
